import img2 from "../Assets/img2.jpg"
import img1 from "../Assets/img1.jpg"
import img3 from "../Assets/img3.jpg"
import img5 from "../Assets/img5.jpg"
import img6 from "../Assets/img6.jpg"
import img7 from "../Assets/img7.jpg"
import img8 from "../Assets/img8.jpg"
import img9 from "../Assets/img9.jpg"
import img10 from "../Assets/img10.jpg"
import img11 from "../Assets/img11.jpg"
import img12 from "../Assets/img12.jpg"
import img13 from "../Assets/img13.jpg"
import img14 from "../Assets/img14.jpg"

export const SliderProducts = [
{
    name: "LUNA",
    detail:"Super Skin Care",
    price:"25",
    img:img1,
},
{
    name: "ELIPSE",
    detail:"Super Skin Care",
    price:"30",
    img:img2,
},
{
    name: "CENAR",
    detail:"Super Skin Care",
    price:"45",
    img:img3,
}
]

export const SkinProducts = [
    {
        name: "JOVYAL",
        detail:"Vitamin C",
        price:"20",
        img:img14,
    },
    {
        name: "EBNY",
        detail:"Cleanser",
        price:"40",
        img:img5,
    },
    {
        name: "SKINBLUR",
        detail:"Moisturizer",
        price:"45",
        img:img6,
    },
    {
        name: "MELBONY V",
        detail:"Toner",
        price:"20",
        img:img7,
    },
    {
        name: "BLUEKING",
        detail:"Cleanser",
        price:"40",
        img:img8,
    },
    {
        name: "SKANZA",
        detail:"Moisturizer",
        price:"45",
        img:img9,
    },
    {
        name: "MULLY",
        detail:"Toner",
        price:"20",
        img:img10,
    },
    {
        name: "BLACKY LOP",
        detail:"Cleanser",
        price:"40",
        img:img11,
    },
    {
        name: "SKYLLA",
        detail:"Toner",
        price:"45",
        img:img12,
    },
    {
        name: "MOTIM",
        detail:"Vitamin C",
        price:"20",
        img:img13,
    },
   
    ]